import { useMutation } from "@apollo/client/react";
import GET_USERS from "../../queries/rolesAndPermissions/getUsers";
import GET_USER_GROUPS from "../../queries/rolesAndPermissions/getUserGroups";
import { DELETE_SKYNET_USER } from "../../mutations/rolesAndPermissions/deleteSkynetUser";

export const useDeleteSkynetUser = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [deleteSkynetUser, { data, loading, error }] = useMutation(
    DELETE_SKYNET_USER,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_USERS, GET_USER_GROUPS],
      awaitRefetchQueries: true,
    },
  );

  return { deleteSkynetUser, data, loading, error };
};
